import { List, Datagrid, TextField, DateField, useListContext, Pagination } from 'react-admin';
import { useEffect, useState } from 'react';
import { useLogDataProvider } from './LogsDataProvider'; // Custom data provider

const LogListWithProvider = (props) => {
  const logDataProvider = useLogDataProvider(); // Use custom data provider
  const { page, perPage, sort, filterValues } = useListContext(); // Extract available values
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const fetchLogs = async () => {
      const { data, total } = await logDataProvider.getList('logs', {
        pagination: { page, perPage },
        sort: { field: sort?.field, order: sort?.order },
        filter: filterValues || {},
      });
      setLogs(data);
      setTotal(total);
    };

    fetchLogs();
  }, [logDataProvider, page, perPage, sort, filterValues]); // Track changes

  return (
    <List {...props} resource="logs" perPage={10} total={total} pagination={<Pagination /> }>
      <Datagrid>
        <DateField source="timestamp" label="Timestamp" />
        <TextField source="level" label="Level" />
        <TextField source="message" label="Message" />
        <TextField source="tenant" label="Tenant" />
        <TextField source="brand" label="Brand" />
      </Datagrid>
    </List>
  );
};

export default LogListWithProvider;